<template>
  <apexchart type="bar" :options="options" :series="series"></apexchart>
</template>

<script>
import axios from 'axios'

export default {
  components: {},
  props: {},
  data: function() {
    return {
      series: []
    }
  },
  computed: {
    options: function() {
      return {
        dataLabels: {
          enabled: false
        },
        noData: {
          text: 'Daten werden geladen...',
          align: 'center',
          verticalAlign: 'middle'
        },
        title: {
          text: 'Jahresvergleich'
        },
        xaxis: {
          type: 'category'
        },
        yaxis: {
          labels: {
            formatter: function(value) {
              var form = new Intl.NumberFormat('de-AT', {
                style: 'currency',
                currency: 'EUR'
              })

              return form.format(value)
            }
          }
        },
        chart: {
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        }
      }
    }
  },

  mounted() {},

  methods: {
    loadData() {
      axios.get('v1/statistics/revenue/year').then(data => {
        var types = []
        var seriesWrapper = []
        data.data.forEach(element => {
          for (var prop in element.y) {
            if (!types.includes(prop)) types.push(prop)
          }
        })
        types.forEach(type => {
          var series = { name: '', data: [] }
          series.name = type
          var dataSeries = []
          data.data.forEach(element => {
            dataSeries.push({ x: element.x, y: element.y[type] })
          })
          series.data = dataSeries
          console.warn(type)
          console.warn(series)
          seriesWrapper.push(series)
        })
        this.series = seriesWrapper
      })
    }
  }
}
</script>
